
import Vue from "vue"

const HOSTINGS: Record<string, { pattern: RegExp, getSrc(id: string): string }> = {
  youtube: {
    pattern: /(?:youtube\.com\/\S*(?:(?:\/e(?:mbed))?\/|watch\?(?:\S*?&?v=))|youtu\.be\/)([a-zA-Z0-9_-]{6,11})/,
    getSrc: id => `https://www.youtube.com/embed/${id}`,
  },
  rutube: {
    pattern: /^https?:\/\/rutube.ru\/video\/(\w+).*$/,
    getSrc: id => `https://rutube.ru/play/embed/${id}`,
  },
}

function urlToSrc (url: string): string {
  for (const hosting of Object.values(HOSTINGS)) {
    const id = hosting.pattern.exec(url)?.[1]
    if (id) return hosting.getSrc(id)
  }
  return ""
}

export default Vue.extend({
  props: {
    url: { type: String, required: true },
  },

  computed: {
    src (): string {
      const { url } = this
      return url ? urlToSrc(this.url) : ""
    },
  },
})
